import type { ShiftRQSchema } from '@libs/data-access/queries'
import moment from 'moment'
import { Shift } from 'snap-redux/modules/shifts'

type Params = {
  userContractId?: number
  weeklyscheduleId: number
  defaultMeal: boolean
  date?: Date | string
}

export const getDefaultShiftModel = ({
  userContractId,
  weeklyscheduleId,
  defaultMeal,
  date = new Date()
}: Params): ShiftRQSchema => {
  return new Shift({
    weeklyschedule_id: weeklyscheduleId,
    user_contract_id: userContractId,
    starts_at: moment(date).format(),
    ends_at: moment(date).format(),
    meal: defaultMeal
  }) as unknown as ShiftRQSchema
}
